/* eslint-disable @typescript-eslint/camelcase */
import { Waypoint } from 'react-waypoint'
import React from 'react'

interface Props {
  percentage: number
}

export function ScrollTracker({ percentage }: Props) {
  return (
    <Waypoint
      scrollableAncestor={window}
      onEnter={props => {
        if (props.previousPosition === Waypoint.below) {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'Interactions',
            event_action: 'vertical-scroll',
            event_label: `${percentage}ContentRead`
          })
        }
      }}
    />
  )
}
